export default __webpack_public_path__ + "static/media/no-result-gradient.197458c5.svg";